import { Box, Dialog, IconButton, Slide } from "@mui/material"
import { handleDownload } from "../../utils/helper"
import SkeletonImage from "./SkeletonImage"
import Icons from "../../assets/js/Icons"
import "slick-carousel/slick/slick.css"
import { Fragment } from "react"

function DocViewer({ show, setShow, document }) {
  // Close dialoge
  const handleClose = () => {
    setShow(false)
  }

  return (
    <Fragment>
      <Dialog
        open={show}
        slots={{
          transition: Slide,
        }}
        keepMounted
        sx={{
          ".MuiPaper-root": {
            display: "block",
            maxHeight: "unset",
            overflowY: "unset",
          }
        }}
        onClose={handleClose}
      >
        <IconButton
          sx={{
            top: "20px",
            right: "30px",
            color: "black",
            position: "absolute",
            bgcolor: "white !important",
          }}
          size="small"
          onClick={handleClose}
        ><Icons.CancelSolid />
        </IconButton>
        <Box
          sx={{
            height: "100%",
            maxWidth: "100%",
            maxHeight: "100%",
          }}
        >
          {document?.fileType !== "PDF" ?
            <Box sx={{ position: "relative" }}>
              <IconButton
                sx={{
                  top: "15px",
                  right: "15px",
                  border: "1px solid",
                  position: "absolute",
                  color: "primary.main",
                  bgcolor: "white !important",
                  borderColor: "primary.main"
                }}
                size="small"
                onClick={() => { handleDownload(document) }}
              ><Icons.CloudDownloadSolid />
              </IconButton>
              <SkeletonImage
                src={document?.fileURL}
              // src="https://images.unsplash.com/photo-1726066012685-f5ccd26b6f55?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
              />
            </Box> :
            <Box
              sx={{
                width: "100%",
                height: "100%",
                position: "relative",
                flexDirection: "column",
                display: "flex !important",
                "embed": {
                  width: "100%",
                  height: "100%",
                  border: "none",
                  flexGrow: "1"
                }
              }}
            >
              <IconButton
                sx={{
                  top: "10px",
                  left: "10px",
                  position: "absolute",
                  color: "primary.main",
                  bgcolor: "white !important",
                }}
                size="small"
                onClick={() => { handleDownload(document) }}
              ><Icons.DashboardSolid />
              </IconButton>
              <embed
                type="application/pdf"
                src={`${document?.fileURL}#toolbar=0&navpanes=0&scrollbar=0`}
              />
            </Box>
          }
        </Box>
      </Dialog>
    </Fragment>
  )
}

export default DocViewer